import { Button } from '@components/general/button';
import { RouteReturn, RsvpNet } from 'networking';
import { useState } from 'react';
import { getError, handleError, handleForm, rsvpSchemas, type Form, type FormErrors } from 'types';
import { EmailInput } from '../email';
import { Input } from '../input';
import { YesOrNo } from '../yes-no';

type RsvpEvent = RouteReturn<typeof RsvpNet.public.get>;

export function EventRsvp({ title, event, onRsvp }: { title: string; event: RsvpEvent; onRsvp: () => void }) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState<Form<typeof rsvpSchemas.rsvp>>({ numPeople: 0 });
  const [errors, setErrors] = useState<FormErrors<typeof rsvpSchemas.rsvp>>(null);
  const [message, setMessage] = useState<string | null>(null);

  return (
    <main className="container mx-auto mb-12 flex max-w-3xl flex-col px-4">
      <section className="rounded-md shadow">
        <div className="flex flex-col rounded-md bg-white px-4 py-5 sm:p-6">
          <h3 className="mb-8 text-center text-2xl font-medium leading-6 md:text-3xl">
            {title} <span className="whitespace-pre">{event.name}</span>
          </h3>

          <div className="grid gap-4 md:grid-cols-2">
            <Input
              className="w-full"
              name="Name"
              autoComplete="name"
              fKey="name"
              form={form}
              setForm={setForm}
              errors={errors}
            />
            <EmailInput
              className="w-full"
              name="Email Address"
              autoComplete="email"
              email={form.email}
              onUpdate={v => handleForm(setForm, setErrors, errors, 'email', v)}
              error={getError(errors, 'email')}
              onUpdateError={v => handleError(setErrors, 'email', v)}
            />
          </div>

          <div className="mt-4 grid gap-4 md:grid-cols-2">
            <YesOrNo
              name="Will you be attending?"
              className="ml-4 py-1"
              value={form.numPeople !== 0}
              onUpdate={v => handleForm(setForm, setErrors, errors, 'numPeople', v ? 1 : 0)}
            />
            {form.numPeople !== 0 && (
              <Input
                className="w-full"
                name="Number of People"
                type="number"
                fKey="numPeople"
                form={form}
                setForm={setForm}
                errors={errors}
              />
            )}
          </div>

          <div className="mt-8 flex flex-col items-center">
            <p className="mb-2 text-center text-red-500 empty:mb-0">{message}</p>
            <Button onClick={submit}>Submit RSVP</Button>
          </div>
        </div>
      </section>
    </main>
  );

  async function submit() {
    if (loading) return;

    const validate = await rsvpSchemas.rsvp.spa(form);
    if (!validate.success) return setErrors(validate.error.format());

    setLoading(true);
    const res = await RsvpNet.public.rsvp(event.id, validate.data);
    setLoading(false);

    if (res.success !== true) return setMessage(res.error.message);
    onRsvp();
  }
}
